
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import utilStyles from "styles/utils.module.scss";
import styles from "pages/store/pouch.module.scss";
import classNames from "classnames";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Axios } from "api";
import CheckBoxChecked from "images/icons/checkbox_checked.svg";
import CheckBoxUnchecked from "images/icons/checkbox_gray.svg";
import CheckBoxSoldOut from "images/icons/checkbox_soldout.svg";
import CloseIcon from "images/icons/X_424242.svg";
import Image from "next/image";
import { customConfirm, formattedPrice, numberWithComma, throttle } from "common/utils";
import Loading from "components/Loading";
import Link from "next/link";
import { getCreatorProductRoute, productsRoute, storeRoute } from "common/const";
import Modal from "components/Modal";
import FullButton from "components/buttons/FullButton";
import OptionSelectionDropDown from "components/dropdown/OptionSelectionDropDown";
import { useRouter } from "next/router";
import UserContext from "context/AuthContext";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ScrollContext from "context/ScrollContext";
import { captureException, captureMessage } from "@sentry/nextjs";
import { removeLocalReferralInfo, setLocalReferralInfo } from "common/referral";
import NewQuantitySelector from "components/buttons/NewQuantitySelector";
import PouchContext from "context/PouchContext";
import { toast } from "react-toastify";
import LoadingDot from "components/LoadingDot";
import TitleBar from "components/layout/TitleBar";
import ToastContext from "context/ToastContext";
import CouponDiscountGaugeBar from "components/rangebar/CouponDiscountGaugeBar";
import { redirectToLogin } from "common/redirect";
import Layout from "components/layout/layout";
import ModalContext from "context/ModalContext";
import useTimer from "hooks/useTimer";
import TextBanner from "components/sections/TextBanner";
import { ProductBasedCurationListSection } from "components/sections/curation/ProductBasedCurationListSection";
import { order } from "api/store/orders";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";
import { localeToCurrency } from "common/locale_utils";
const PouchItemCard = (props) => {
    const { item, currency, changeItem, deleteItem, isLoading, toggleItemSelection, selectedItems, openModal, syncCountTrigger, priceInfo, isPriceLoading } = props;
    const [isLiked, setIsLiked] = useState(false);
    const router = useRouter();
    const referralIdToNickname = props.referralIdToNickname || {};
    const { openAppInstallModal } = useContext(ModalContext);
    const { t } = useTranslation('store-pouch');
    useEffect(() => {
        if (t.toLocaleString() === 'ko') {
            openAppInstallModal(true);
        }
    }, []);
    const increaseOptionCount = (diff) => {
        const pouchId = item.id;
        const count = item.count + diff;
        typeof mixpanel !== 'undefined' && mixpanel.track('PouchOptionCountChangeByButton', {
            optionId: item.option.id,
            count: count,
            increase: diff > 0
        });
        changeItem(pouchId, null, count, item.referral_id, item.referral_post_id);
    };
    const deleteOption = () => {
        const pouchId = item.id;
        typeof mixpanel !== 'undefined' && mixpanel.track('PouchOptionDelete', {
            optionId: item.option.id
        });
        deleteItem(pouchId);
    };
    const setCount = (count) => {
        const pouchId = item.id;
        typeof mixpanel !== 'undefined' && mixpanel.track('PouchOptionCountChangeByInput', {
            optionId: item.option.id,
            count: count
        });
        changeItem(pouchId, null, count, item.referral_id, item.referral_post_id);
    };
    const isSoldOut = item.option.is_sold_out;
    const onProductClick = () => {
        if (item) {
            const productId = item.option.product.id;
            removeLocalReferralInfo(productId);
            if (item.referral_id) {
                setLocalReferralInfo(productId, item.referral_id, item.referral_post_id);
            }
        }
    };
    const productLink = (item.option.product.override_link ?
        (item.option.product.override_link) :
        (!!item.referral_id ?
            `${getCreatorProductRoute(item.referral_id, item.option.product.id)}` :
            `${productsRoute}/${item.option.product.id}`));
    const onOptionChangeClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('PouchOptionChangeModalOpen');
        openModal();
    };
    const handlePouchToggle = () => {
        if (isSoldOut) {
            return;
        }
        toggleItemSelection(item);
    };
    const discountedPrice = priceInfo.option_id_to_discount_info[item.option.id]?.discounted_price || item.option.discounted_price;
    const discountRate = priceInfo.option_id_to_discount_info[item.option.id]?.discount_rate || item.option.discount_rate;
    return (<div className={styles.listCardContainer}>
            <div className={styles.listCardWrapper}>
                <div onClick={handlePouchToggle} className={styles.checkboxWrapper}>
                    {!!selectedItems[item.id] ?
            <CheckBoxChecked viewBox="0 0 24 24" className={styles.checkBox}/>
            :
                (!isSoldOut ?
                    <CheckBoxUnchecked viewBox="0 0 24 24" className={classNames(styles.checkBox)}/>
                    :
                        <CheckBoxSoldOut viewBox="0 0 24 24" className={classNames(styles.checkBox)}/>)}
                </div>
                <div className={styles.cardContentContainer}>
                    <div className={styles.imageWrapper}>
                        <Link href={productLink}>
                            <a onClick={onProductClick}>
                                {isSoldOut && <div className={styles.soldOut}>{t('PouchItemCard.soldOut')}</div>}
                                <Image unoptimized src={item.option.product.thumbnail_url} layout="fill" objectFit="cover"/>
                            </a>
                        </Link>
                    </div>
                    <div className={styles.infoContainer}>
                        {item.referral_id && (item.referral_id in referralIdToNickname) &&
            <span className={styles.sellerName}>#{referralIdToNickname[item.referral_id]}</span>}
                        <Link href={productLink}>
                            <a onClick={onProductClick}>
                                <span className={classNames(styles.productName, isSoldOut ? styles.soldOutFontColor : undefined)}>{item.option.product.name}</span>
                            </a>
                        </Link>
                        <div className={styles.nameContainer}>
                            <span className={classNames(styles.optionName, isSoldOut ? styles.soldOutFontColor : undefined)}>{item.option.name}</span>
                            {((!Boolean(item.option.product.product_option_group_list) || item.option.product.product_option_group_list.length === 0) && item.option.product.options.length > 1) &&
            <span className={classNames(styles.optionName, styles.changeOption)} onClick={onOptionChangeClick}>
                                    {t('PouchItemCard.optionChange')}
                                </span>}
                        </div>
                    </div>
                </div>
                <div className={styles.closeWrapper} onClick={!isLoading ? deleteOption : () => {
        }}>
                    <CloseIcon viewBox="0 0 20 20" className={classNames(utilStyles.cursorPointer, styles.close)}/>
                </div>
            </div>
            <div className={styles.priceContainer}>
                <div className={classNames(styles.priceInfoContainer)}>
                    <div className={styles.quantitySelectorWrapper}>
                        <NewQuantitySelector disabled={isLoading || isSoldOut} dark={isSoldOut} fontSize={14} count={item.count} onMinus={() => increaseOptionCount(-1)} onPlus={() => increaseOptionCount(1)} setCount={setCount} syncCountTrigger={syncCountTrigger}/>
                    </div>
                    <div className={styles.priceInfoWrapper}>
                        {isPriceLoading
            ?
                <div className={styles.loadingWrapper}>
                                    <LoadingDot />
                                </div>
            :
                <>
                                    {item.option.price !== discountedPrice &&
                        <div className={styles.originalPriceWrapper}>
                                            <span className={styles.originalPrice}>
                                                {t('PouchItemCard.price', { price: formattedPrice(item.option.price * item.count, currency) + t(`common:currency.${currency}`) })}
                                            </span>
                                        </div>}
                                    <div className={styles.cardPriceContainer}>
                                        {Boolean(discountRate) && discountRate > 0 &&
                        <span className={classNames(styles.discountRate, isSoldOut ? styles.soldOutFontColor : undefined)}>
                                                <span>{discountRate}%</span>
                                            </span>}
                                        <Trans i18nKey="store-pouch:PouchItemCard.priceComponent" components={[
                        <span className={classNames(styles.cardPrice, isSoldOut ? styles.soldOutFontColor : undefined)}/>,
                        <span className={classNames(styles.cardWon, utilStyles.verticalMiddle, isSoldOut ? styles.soldOutFontColor : undefined)}/>
                    ]} values={{
                        price: formattedPrice(discountedPrice * item.count, currency),
                        currency: t(`common:currency.${currency}`)
                    }}/>
                                    </div>
                                </>}
                    </div>
                </div>
            </div>
        </div>);
};
const EmptyPouchItemCard = (props) => {
    const isMobile = useMediaQuery(`(max-width:${utilStyles.breakpointMobile})`);
    const { t } = useTranslation('store-pouch');
    return (<div className={styles.listCardContainer}>
            {isMobile && <div className={utilStyles.mobileBorder}/>}
            <div className={styles.emptyContainer}>
                <div className={styles.emptyWrapper}>
                    <span className={styles.emptyText}>{t('EmptyPouchItemCard.emptyText')}</span>
                    <Link href={storeRoute}>
                        <a className={styles.storeButton}>{t('EmptyPouchItemCard.storeButton')}</a>
                    </Link>
                </div>
            </div>
        </div>);
};
export const deleteLocalPouchItems = (pouchContext, ordNum) => {
    const targetIds = JSON.parse(window.sessionStorage.getItem(`checkout_requested_pouch_item_ids_${ordNum}`)) || [];
    const pouchItems = JSON.parse(window.localStorage.getItem(`pouch_items`)) || [];
    const finalItems = pouchItems.filter(x => !targetIds.includes(x.id));
    pouchContext.setPouchItems(finalItems);
    window.sessionStorage.removeItem(`checkout_requested_pouch_item_ids_${ordNum}`);
};
const OptionChangeModalContent = (props) => {
    const { pouchItem, close, changeItem } = props;
    // const [options, setOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [isExpanded, setIsExpanded] = useState(false);
    const isMobile = useMediaQuery(`(max-width:${utilStyles.breakpointMobile})`);
    const { t } = useTranslation('store-pouch');
    if (!pouchItem)
        return <div />;
    const onOptionChangeSelect = (e) => {
        typeof mixpanel !== 'undefined' && mixpanel.track('PouchOptionChangeSelect');
        console.log('onOptionChangeSelect', e);
        setSelectedOption(e);
    };
    const onOptionChangeConfirm = async () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('PouchOptionChangeConfirm');
        if (!selectedOption) {
            toast.info(t('OptionChangeModalContent.selectOption'));
        }
        else {
            await changeItem(pouchItem.id, selectedOption, null, pouchItem.referral_id, pouchItem.referral_post_id);
            close();
        }
    };
    const onOptionChangeCancel = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('PouchOptionChangeCancel');
        close();
    };
    return (<div className={styles.modalContentContainer}>
            {!isMobile && <span className={styles.modalTitle}>{t('OptionChangeModalContent.modalTitle')}</span>}
            <OptionSelectionDropDown isExpanded={isExpanded} setIsExpanded={setIsExpanded} small title={selectedOption ? selectedOption.name : t('OptionChangeModalContent.select')} basePrice={pouchItem.option.discounted_price} options={pouchItem.option.product.leaf_options} onClick={onOptionChangeSelect} product={pouchItem.option.product} isMultipleSelectNotAllowed selectedOptions={selectedOption ? { [selectedOption.id]: 1 } : {}}/>
            <div className={classNames(utilStyles.flexRow, styles.modalButtonContainer)} style={{ marginTop: isMobile ? 38 : 32 }}>
                <div style={{ flex: 1 }}>
                    <FullButton onClick={onOptionChangeCancel} height={48} fontSize={16} light title={t('OptionChangeModalContent.cancel')}/>
                </div>
                <div style={{ flex: 1 }}>
                    <FullButton onClick={onOptionChangeConfirm} height={48} fontSize={16} title={t('OptionChangeModalContent.confirm')}/>
                </div>
            </div>
        </div>);
};
const _Pouch = (props) => {
    const [pouchItems, setPouchItems] = useState([]);
    const [announcements, setAnnouncements] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isPriceLoading, setIsPriceLoading] = useState(false);
    const [initialized, setInitialized] = useState(false);
    const [selectedItems, setSelectedItems] = useState({});
    const isInitializedRef = useRef(false);
    const [targetItem, setTargetItem] = useState(null);
    const [error, setError] = useState(false);
    const modalContext = useContext(ModalContext);
    const { openCouponModal, closeModal, isModalOpenable, couponModalInfo, openCouponModalByIdentifier } = modalContext;
    const { t } = useTranslation('store-pouch');
    const modalAlreadyOpen = useRef(false);
    const selectedModalRef = useRef(null);
    useEffect(() => {
        if (!couponModalInfo)
            return;
        if (pouchItems.length === 0)
            return;
        const location = typeof window === 'undefined' ? null : window.location.pathname;
        const existingProductIds = new Set(pouchItems.map(e => e.option.product.id));
        const modals = couponModalInfo.modal_list.filter(modal => modal.pathname_whitelist.includes(location));
        for (const modal of modals) {
            const targetProductIds = modal.pouch_target_product_ids;
            if (targetProductIds && targetProductIds.length > 0) {
                if (targetProductIds.filter(e => existingProductIds.has(e)).length === 0) {
                    continue;
                }
            }
            if (!isModalOpenable(modal)) {
                continue;
            }
            if (modalAlreadyOpen.current) {
                continue;
            }
            selectedModalRef.current = modal;
            openCouponModal(modal);
            modalAlreadyOpen.current = true;
            break;
        }
    }, [pouchItems, couponModalInfo]);
    const { user, fetchUser } = useContext(UserContext);
    const pouchContext = useContext(PouchContext);
    const router = useRouter();
    const locale = router.locale;
    const [selectedItemPriceInfo, setSelectedItemPriceInfo] = useState({
        total_price: 0,
        total_discounted_price: 0,
        option_id_to_discount_info: {},
        next_available_coupons: [],
        delivery_fee: 0
    });
    const totalPrice = useMemo(() => {
        return selectedItemPriceInfo.total_price;
    }, [selectedItemPriceInfo]);
    const totalDiscountPrice = useMemo(() => {
        return selectedItemPriceInfo.total_discounted_price;
    }, [selectedItemPriceInfo]);
    const currency = useMemo(() => {
        return selectedItemPriceInfo.currency;
    }, [selectedItemPriceInfo]);
    const shippingFee = useMemo(() => {
        return selectedItemPriceInfo.delivery_fee;
    }, [selectedItemPriceInfo]);
    const shippingFeeText = useMemo(() => {
        if (shippingFee === 0) {
            return t('Pouch.freeShipping');
        }
        return '+' + formattedPrice(shippingFee, selectedItemPriceInfo.currency) + t(`common:currency.${currency}`);
    }, [selectedItemPriceInfo]);
    const taxPrice = useMemo(() => {
        if (Boolean(selectedItemPriceInfo?.total_tax_price)) {
            return selectedItemPriceInfo.total_tax_price;
        }
        return 0;
    }, [selectedItemPriceInfo]);
    const disabled = totalPrice <= 0 || isLoading || isPriceLoading;
    const maxOpensAtTimestamp = pouchItems.filter(e => e.id in selectedItems).reduce((acc, cur) => {
        const opensAtTimestamp = cur.option.product.opens_at_timestamp;
        if (opensAtTimestamp) {
            return Math.max(acc, opensAtTimestamp);
        }
        return acc;
    }, 0);
    const { timeString } = useTimer(maxOpensAtTimestamp);
    const purchaseButtonText = useMemo(() => {
        return user
            ? t('Pouch.order', { price: !disabled ? numberWithComma(totalDiscountPrice) : '' })
            : t('Pouch.loginToOrder');
    }, [user, disabled, totalDiscountPrice, t]);
    const initialize = async () => {
        const prevPouchItemIds = pouchItems.map(x => x.id);
        if (user) {
            setIsLoading(true);
            try {
                const res = await Axios.get('v2/store/pouch/');
                console.log('initialize', res.data);
                if (res.status < 400) {
                    const pouchInfo = res.data;
                    const fetchedPouchItems = pouchInfo.pouch_items;
                    if (isInitializedRef.current) {
                        const newItems = fetchedPouchItems.filter(x => !prevPouchItemIds.includes(x.id));
                        if (newItems.length > 0) {
                            setSelectedItems(prev => {
                                const newSelectedItems = { ...prev };
                                for (const item of newItems) {
                                    newSelectedItems[item.id] = 1;
                                }
                                return newSelectedItems;
                            });
                        }
                        return;
                    }
                    isInitializedRef.current = true;
                    const newSelectedItems = {};
                    for (const item of fetchedPouchItems) {
                        if (!item.option.is_sold_out) {
                            newSelectedItems[item.id] = 1;
                        }
                    }
                    setAnnouncements(pouchInfo.announcements);
                    setPouchItems(fetchedPouchItems);
                    setSelectedItems(newSelectedItems);
                }
                else {
                    setError(true);
                }
            }
            catch (e) {
                captureException(e);
                setError(false);
            }
            finally {
                setIsLoading(false);
                setInitialized(true);
                isInitializedRef.current = true;
            }
        }
        else {
            setIsLoading(true);
            const pseudoPouchItems = JSON.parse(window.localStorage.getItem('pouch_items')) || [];
            const options = pseudoPouchItems.map(e => {
                return { option_id: e.option_id, referral_id: e.referral_id };
            });
            try {
                const res = await Axios.post('v1/store/get-options/', { options });
                if (res.status < 400) {
                    const optionIdToOptionDict = {};
                    for (const option of res.data) {
                        optionIdToOptionDict[option.id] = option;
                    }
                    const newPouchItems = pseudoPouchItems.map(e => Object.assign(JSON.parse(JSON.stringify(e)), { option: optionIdToOptionDict[e.option_id] })).filter(e => !!e.option);
                    const newSelectedItems = {};
                    const newItems = newPouchItems.filter(x => !prevPouchItemIds.includes(x.id));
                    if (!isInitializedRef.current) {
                        for (const item of pseudoPouchItems) {
                            const option = optionIdToOptionDict[item.option_id];
                            if (option && !option.is_sold_out) {
                                newSelectedItems[item.id] = 1;
                            }
                        }
                    }
                    isInitializedRef.current = true;
                    for (const item of newItems) {
                        newSelectedItems[item.id] = 1;
                    }
                    setPouchItems(newPouchItems);
                    setSelectedItems(newSelectedItems);
                }
                else {
                    setError(true);
                }
            }
            catch (e) {
                captureException(e);
                setError(false);
            }
            finally {
                setIsLoading(false);
                setInitialized(true);
                isInitializedRef.current = true;
            }
        }
    };
    useEffect(async () => {
        if (user === undefined) {
            return;
        }
        initialize();
    }, [user]);
    const [referralIdToNickname, setReferralIdToNickname] = useState({});
    useEffect(async () => {
        try {
            const res = await Axios.post('v1/palette/get-creator-nickname/', {
                referral_ids: pouchItems.filter(x => x.referral_id).map(x => x.referral_id)
            });
            if (res.status < 400) {
                setReferralIdToNickname(res.data.referral_id_to_nickname);
                return;
            }
        }
        catch (e) {
            captureException(e);
        }
        finally {
        }
        setReferralIdToNickname({});
    }, [pouchItems]);
    const [syncCountTrigger, setSyncCountTrigger] = useState({});
    const pouchItemsBrandNameGroup = useMemo(() => {
        const pouchGroup = {};
        for (const item of pouchItems) {
            const brand_name = item.option.product.brand_name;
            if (pouchGroup[brand_name] === undefined) {
                pouchGroup[brand_name] = [];
            }
            pouchGroup[brand_name].push(item);
        }
        return pouchGroup;
    }, [pouchItems]);
    const changeItem = async (pouchId, option, count, referralId, referralPostId) => {
        if (user) {
            try {
                setIsLoading(true);
                const loggingData = {
                    pouch_id: pouchId,
                    target_option_id: !!option ? option.id : null,
                    count: count,
                    referral_id: referralId,
                    referral_post_id: referralPostId
                };
                typeof mixpanel !== 'undefined' && mixpanel.track('ChangePouchItem', loggingData);
                const res = await Axios.patch(`v1/store/pouch/${pouchId}/`, {
                    option_id: !!option ? option.id : null,
                    count: count,
                    referral_id: referralId,
                    referral_post_id: referralPostId
                });
                if (res.status < 400) {
                    const prevItem = res.data.prev;
                    const currItem = res.data.changed;
                    setPouchItems((prevItems) => {
                        const newPouchItems = [...prevItems].filter(pitem => {
                            return (pitem.id !== prevItem.id) && (pitem.id !== currItem.id);
                        });
                        newPouchItems.push(currItem);
                        newPouchItems.sort((a, b) => b.id - a.id);
                        return newPouchItems;
                    });
                    setSelectedItems(oldItems => {
                        return Object.fromEntries(Object.entries(oldItems).map(([k, v]) => {
                            if (parseInt(k) === prevItem.id || parseInt(k) === currItem.id) {
                                return [currItem.id, 1];
                            }
                            return [k, v];
                        }));
                    });
                    fetchUser();
                }
                else {
                    toast.info(t('Pouch.temporaryError'));
                }
                setSyncCountTrigger(Object());
            }
            catch (e) {
                captureException(e);
                toast.info(t('Pouch.temporaryError'));
            }
            finally {
                setIsLoading(false);
            }
        }
        else {
            const pseudoPouchItems = JSON.parse(window.localStorage.getItem('pouch_items'));
            if (!!option && !Boolean(option?.product?.opens_at_timestamp)) {
                const product = pouchItems.filter(e => e.id === pouchId).map(e => e.option.product)[0];
                option = Object.assign(JSON.parse(JSON.stringify(option)), { product: product });
            }
            if (count) {
                const newPseudoPouchItems = pseudoPouchItems.map(e => e.id === pouchId ? Object.assign({}, JSON.parse(JSON.stringify(e)), { count: count }) : e);
                pouchContext.setPouchItems(newPseudoPouchItems);
                setPouchItems(oldItems => {
                    return oldItems.map(e => {
                        if (e.id === pouchId) {
                            e.count = count;
                        }
                        return e;
                    });
                });
            }
            else {
                if (pseudoPouchItems.filter(e => e.option_id === option.id).length > 0) {
                    const previousItem = pseudoPouchItems.filter(e => e.id === pouchId)[0];
                    const currentItem = pseudoPouchItems.filter(e => e.option_id === option.id)[0];
                    if (currentItem.id === previousItem.id) {
                        return;
                    }
                    const newPseudoPouchItems = pseudoPouchItems.filter(e => e.option_id !== option.id).map(e => e.id === pouchId ? Object.assign(JSON.parse(JSON.stringify(e)), {
                        option_id: option.id,
                        count: previousItem.count + currentItem.count
                    }) : e);
                    pouchContext.setPouchItems(newPseudoPouchItems);
                    setPouchItems(oldItems => {
                        return oldItems.filter(e => e.option.id !== option.id).map(e => e.id === pouchId ? Object.assign(JSON.parse(JSON.stringify(e)), {
                            option: option,
                            count: previousItem.count + currentItem.count
                        }) : e);
                    });
                }
                else {
                    const newPseudoPouchItems = pseudoPouchItems.map(e => e.id === pouchId ? Object.assign(JSON.parse(JSON.stringify(e)), { option_id: option.id }) : e);
                    pouchContext.setPouchItems(newPseudoPouchItems);
                    setPouchItems(oldItems => {
                        return oldItems.map(e => e.id === pouchId ? Object.assign(JSON.parse(JSON.stringify(e)), { option: option }) : e);
                    });
                }
            }
            setSyncCountTrigger(Object());
        }
    };
    useEffect(() => {
        if (!isInitializedRef.current) {
            return;
        }
        updatePriceInfo();
    }, [selectedItems, syncCountTrigger]);
    const { currentCouponModalRef } = useContext(ModalContext);
    useEffect(() => {
        updatePriceInfo();
    }, [currentCouponModalRef.current]);
    const updatePriceInfo = async () => {
        setIsPriceLoading(true);
        const selectedPouchItems = pouchItems.filter(e => selectedItems[e.id]);
        await fetchPriceInfo(selectedPouchItems, (res) => setSelectedItemPriceInfo(res));
        setIsPriceLoading(false);
    };
    const fetchPriceInfo = async (items, cb) => {
        try {
            const option_count_list = [];
            for (let pouchItem of items) {
                option_count_list.push({
                    option_id: pouchItem.option.id,
                    count: pouchItem.count,
                    referral_id: pouchItem.referral_id
                });
            }
            const res = await Axios.post('v1/store/price/', {
                light_option_count_with_seller_list: option_count_list,
                should_fetch_next_available_coupons: true
            });
            if (res.status < 400) {
                console.log('res, ', res.data);
                cb(res.data);
            }
            else {
                captureMessage(JSON.stringify(res.data));
            }
        }
        catch (e) {
            captureException(e);
            return null;
        }
        finally {
        }
    };
    const validatePurchase = () => {
        if (timeString) {
            toastContext.closeAndOpenToast(t('Pouch.notOpenYet'));
            return false;
        }
        return true;
    };
    const checkOut = async (isGift) => {
        if (!validatePurchase()) {
            return;
        }
        const payCurrency = localeToCurrency(router.locale);
        const selectedPouchItems = pouchItems.filter(e => selectedItems[e.id]);
        const data = !!user ?
            {
                pouch_ids: selectedPouchItems.map(e => e.id),
                is_gift: !!isGift,
                currency: payCurrency
            }
            :
                {
                    checkout_items: selectedPouchItems.map(e => {
                        return {
                            option_id: e.option.id, count: e.count, referral_id: e.referral_id,
                            reservation_time: null
                        };
                    }),
                    is_gift: !!isGift,
                    currency: payCurrency
                };
        const totalCount = selectedPouchItems.reduce((acc, curr) => acc + curr.count, 0);
        const totalUniqueOptionCount = selectedPouchItems.length;
        typeof mixpanel !== 'undefined' && mixpanel.track('PouchCheckout', {
            totalCount,
            totalPrice: totalDiscountPrice,
            totalUniqueOptionCount,
            isGift: isGift
        });
        setIsLoading(true);
        try {
            const res = await order(data);
            if (res.status < 400) {
                const ordNum = res.data.order_number;
                window.sessionStorage.setItem(`checkout_requested_pouch_items_${ordNum}`, JSON.stringify(selectedPouchItems));
                router.push(`/store/orders/${ordNum}/checkout`);
            }
            else {
                captureMessage(JSON.stringify(res.data));
                toast.info(res.data.display_message || t('Pouch.temporaryError'));
            }
            console.log(res);
        }
        catch (e) {
            captureException(e);
            toast.info(t('Pouch.temporaryError'));
        }
        finally {
            setIsLoading(false);
        }
    };
    const handleLoginAndCheckout = () => {
        if (!user) {
            redirectToLogin(router, true);
        }
        else {
            checkOut(false);
        }
    };
    const deleteItem = async (pouchId) => {
        const filteredOptions = pouchItems.filter(e => e.id === pouchId);
        const option = (filteredOptions && filteredOptions.length > 0) ? filteredOptions[0].option : null;
        const isOptionGroupExists = option && option.product.product_option_group_list && option.product.product_option_group_list.length > 0;
        customConfirm(isOptionGroupExists ? t('Pouch.deleteConfirmWithOptions') : t('Pouch.deleteConfirm2'), t('Pouch.delete'), t('Pouch.cancel'), () => {
            deleteItemConfirm(pouchId);
        }, () => {
        });
    };
    const deleteItemConfirm = async (pouchId) => {
        if (user) {
            try {
                setIsLoading(true);
                const res = await Axios.delete(`v1/store/pouch/${pouchId}/`);
                console.log('res', res);
                if (res.status < 400) {
                    const deletedItemIds = res.data.deleted_pouch_ids || [parseInt(pouchId)];
                    setPouchItems(oldItems => oldItems.filter(e => !deletedItemIds.includes(e.id)));
                    setSelectedItems(oldItems => {
                        return Object.fromEntries(Object.entries(oldItems).filter(([k, v]) => !deletedItemIds.includes(parseInt(k))));
                    });
                    fetchUser();
                }
                else {
                    toast.info(t('Pouch.temporaryError'));
                }
            }
            catch (e) {
                captureException(e);
                toast.info(t('Pouch.temporaryError'));
            }
            finally {
                setIsLoading(false);
            }
        }
        else {
            const pseudoPouchItems = JSON.parse(window.localStorage.getItem('pouch_items'));
            const newPseudoPouchItems = pseudoPouchItems.filter(e => e.id !== pouchId);
            pouchContext.setPouchItems(newPseudoPouchItems);
            setPouchItems(oldItems => {
                return oldItems.filter(e => e.id !== pouchId);
            });
            setSelectedItems(oldItems => {
                return Object.fromEntries(Object.entries(oldItems).filter(([k, v]) => k.toString() !== pouchId.toString()));
            });
        }
    };
    const deleteItemsById = async (targetIds) => {
        if (user) {
            try {
                setIsLoading(true);
                const res = await Axios.delete('v1/store/pouch/', { data: { ids: targetIds } });
                if (res.status < 400) {
                    const ids = res.data;
                    setPouchItems(oldItems => oldItems.filter(e => !ids.includes(e.id)));
                    setSelectedItems(oldItems => {
                        return Object.fromEntries(Object.entries(oldItems).filter(([k, v]) => !ids.includes(parseInt(k))));
                    });
                    fetchUser();
                }
                else {
                    toast.info(t('Pouch.temporaryError'));
                }
            }
            catch (e) {
                captureException(e);
                toast.info(t('Pouch.temporaryError'));
            }
            finally {
                setIsLoading(false);
            }
        }
        else {
            const pseudoPouchItems = JSON.parse(window.localStorage.getItem('pouch_items'));
            const newPseudoPouchItems = pseudoPouchItems.filter(e => !targetIds.map(el => el.toString()).includes(e.id.toString()));
            pouchContext.setPouchItems(newPseudoPouchItems);
            setPouchItems(oldItems => {
                return oldItems.filter(e => !targetIds.map(e => e.toString()).includes(e.id.toString()));
            });
            setSelectedItems(oldItems => {
                return Object.fromEntries(Object.entries(oldItems).filter(([k, v]) => !targetIds.map(e => e.toString()).includes(k)));
            });
        }
    };
    const toggleItemSelection = (pouchItem) => {
        console.log('toggleItemSelection', pouchItem);
        if (selectedItems[pouchItem.id]) {
            setSelectedItems(oldItems => {
                const newObj = JSON.parse(JSON.stringify(oldItems));
                delete newObj[pouchItem.id];
                return newObj;
            });
        }
        else {
            setSelectedItems(oldItems => {
                const newObj = JSON.parse(JSON.stringify(oldItems));
                newObj[pouchItem.id] = 1;
                return newObj;
            });
        }
    };
    const toggleAllItems = () => {
        let selectAll = true;
        if (Object.keys(selectedItems).length === pouchItems.filter(e => !e.option.is_sold_out).length && pouchItems.length > 0) {
            setSelectedItems({});
            selectAll = false;
        }
        else {
            const allIdDict = {};
            for (const item of pouchItems) {
                if (!item.option.is_sold_out) {
                    allIdDict[item.id] = 1;
                }
            }
            setSelectedItems(allIdDict);
        }
        typeof mixpanel !== 'undefined' && mixpanel.track('PouchToggleAllItemsClick', {
            selectAll
        });
    };
    const isMobile = useMediaQuery(`(max-width:${utilStyles.breakpointMobile})`);
    const { shouldHideNavBar } = useContext(ScrollContext);
    const onDeleteSoldOutItemsClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('PouchDeleteSoldOutItemsClick');
        deleteItemsById(pouchItems.filter(e => e.option.is_sold_out).map(e => e.id));
    };
    const onDeleteSelectedItemsClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('PouchDeleteSelectedItemsClick');
        deleteItemsById(Object.keys(selectedItems));
    };
    const toastContext = useContext(ToastContext);
    const handleChangeOptionModalOpen = (pouchItem) => {
        toastContext.closeToast();
        setTargetItem(pouchItem);
    };
    const nextAvailableCoupon = selectedItemPriceInfo.next_available_coupons[0];
    const bestAvailableCoupon = selectedItemPriceInfo.best_available_coupon;
    const buttonRef = useRef(null);
    useEffect(() => {
        const handleScroll = throttle((e) => {
            if (buttonRef.current) {
                buttonRef.current.classList.toggle(styles.shadow, buttonRef.current.offsetTop - window.scrollY > 500);
            }
        }, 100);
        window.addEventListener('scroll', handleScroll, true);
        return () => {
            window.removeEventListener('scroll', handleScroll, true);
        };
    }, []);
    const handleGoToStoreButtonClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('PouchEmptyGoToStoreButtonClick');
    };
    const handleDisabledButtonClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('PouchUnselectedButtonClick');
        toastContext.closeToast();
        const toastId = toast.info(totalPrice <= 0 ? t('Pouch.selectProduct') : t('Pouch.loading'));
        toastContext.registerToast(toastId);
    };
    const handleDisabledGiftButtonClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('PouchUnselectedGiftButtonClick');
        toastContext.closeToast();
        const toastId = toast.info(totalPrice <= 0 ? t('Pouch.selectProduct') : t('Pouch.loading'));
        toastContext.registerToast(toastId);
    };
    const handleAnnouncementClick = (announcement, idx) => {
        typeof mixpanel !== 'undefined' && mixpanel.track('PouchAnnouncementClick', {
            text: announcement.text,
            link: announcement.link,
            modal_identifier: announcement.modal_identifier,
            idx
        });
        if (announcement.modal_identifier) {
            openCouponModalByIdentifier(announcement.modal_identifier);
            return;
        }
        if (announcement.link) {
            router.push(announcement.link);
        }
    };
    return (<>
            <Modal isOpen={!!targetItem} showOverflow={!isMobile} bottom={isMobile} width={isMobile ? "100%" : 416} close={() => setTargetItem(null)}>
                <OptionChangeModalContent pouchItem={targetItem} close={() => setTargetItem(null)} changeItem={changeItem}/>
            </Modal>
            <div className={classNames(utilStyles.topSticky, utilStyles.whiteBackground)}>
                <div className={utilStyles.sidePadding}>
                    <TitleBar title={t('Pouch.title')} isBack close={() => router.back()}/>
                </div>
                {locale === 'ko' ?
            (announcements && announcements.length > 0) ?
                <TextBanner banners={announcements} onClick={handleAnnouncementClick}/> :
                <div className={styles.announcement}>
                        <span>{t('Pouch.freeShipping')}</span>
                    </div> : <div />}
            </div>
            <div className={classNames(styles.body)}>
                <div className={styles.listingSection}>
                    {isLoading && !initialized ?
            <Loading style={{ marginTop: 150, marginBottom: 300 }}/>
            :
                pouchItems.length > 0
                    ?
                        <>
                                    <div className={styles.filterBar}>
                                        <div onClick={toggleAllItems} className={utilStyles.cursorPointer}>
                                            {Object.keys(selectedItems).length === pouchItems.filter(e => !e.option.is_sold_out).length && Object.keys(selectedItems).length > 0
                                ?
                                    <CheckBoxChecked className={styles.checkBox}/>
                                :
                                    <CheckBoxUnchecked className={styles.checkBox}/>}
                                            <span className={styles.selectAll}>
                                                {t('Pouch.selectAll', { selectedCount: Object.keys(selectedItems).length, totalCount: pouchItems.length })}
                                            </span>
                                        </div>
                                        <span className={styles.deleteText} onClick={() => {
                                customConfirm(t("Pouch.deleteConfirm3"), t('Pouch.delete'), t('Pouch.cancel'), onDeleteSelectedItemsClick, () => {
                                });
                            }}>{t('Pouch.deleteSelected')}</span>
                                    </div>
                                    {Object.entries(pouchItemsBrandNameGroup).map(([brandName, items]) => {
                                return (<div key={brandName}>
                                                    <div className={utilStyles.mobileBorder}/>
                                                    <div className={styles.titleBar}>
                                                        <span className={styles.brand}>{brandName}</span>
                                                    </div>
                                                    {items.map(e => {
                                        return (<PouchItemCard key={e.id} item={e} currency={currency} openModal={() => handleChangeOptionModalOpen(e)} toggleItemSelection={toggleItemSelection} selectedItems={selectedItems} changeItem={changeItem} deleteItem={deleteItem} isLoading={isLoading || isPriceLoading} syncCountTrigger={syncCountTrigger} referralIdToNickname={referralIdToNickname} priceInfo={selectedItemPriceInfo} isPriceLoading={isPriceLoading}/>);
                                    })}
                                                </div>);
                            })}
                                </>
                    :
                        <div className={styles.emptyPouch}>
                                    <span className={styles.emptyPouchText}>{t('Pouch.emptyPouch')}</span>
                                    <Link href={storeRoute}>
                                        <a className={styles.emptyPouchGoToStoreButtonWrapper}>
                                            <FullButton height={40} onClick={handleGoToStoreButtonClick}>
                                                <span className={styles.emptyPouchButtonText}>{t('Pouch.goToStore')}</span>
                                            </FullButton>
                                        </a>
                                    </Link>
                                </div>}
                </div>
                <div className={utilStyles.mobileBorder}/>
                <ProductBasedCurationListSection onPouchAdd={() => {
            isInitializedRef.current = false;
            initialize();
        }} curationKey="pouch" location="pouch" isInitialized={isInitializedRef.current} productOptionIds={pouchItems.map(e => e.option.id)} isAddToPouchVisible isFoldable/>
                {pouchItems.length > 0 &&
            <>
                        <span className={styles.orderTitle}>{t('Pouch.orderAmount')}</span>
                        <div className={styles.priceSection}>
                            <div className={styles.orderInfoContainer}>
                                {isPriceLoading
                    ? <LoadingDot />
                    :
                        <>
                                            <div className={classNames(utilStyles.flexRow, utilStyles.justifyContentSpaceBetween, utilStyles.alignItemsCenter, styles.orderRow)}>
                                                <span className={styles.orderSubTitle}>{t('Pouch.totalProductPrice')}</span>
                                                <div>
                                                    <Trans i18nKey="store-pouch:Pouch.price" values={{ price: `${formattedPrice(totalPrice, currency)}`, currency: t(`common:currency.${currency}`) }} components={[<span className={styles.price}/>, <span className={classNames(styles.price, styles.won)}/>]}/>
                                                </div>
                                            </div>
                                            <div className={classNames(utilStyles.flexRow, utilStyles.justifyContentSpaceBetween, utilStyles.alignItemsCenter, styles.orderRow)}>
                                                <span className={styles.orderSubTitle}>{t('Pouch.discountAmount')}</span>
                                                <div>
                                                    <Trans i18nKey="store-pouch:Pouch.price" values={{ price: `-${formattedPrice(totalPrice - totalDiscountPrice, currency)}`, currency: t(`common:currency.${currency}`) }} components={[<span className={styles.price}/>, <span className={classNames(styles.price, styles.won)}/>]}/>
                                                </div>
                                            </div>
                                            {taxPrice > 0 &&
                                <div className={classNames(utilStyles.flexRow, utilStyles.justifyContentSpaceBetween, utilStyles.alignItemsCenter, styles.orderRow)}>
                                                    <span className={styles.orderSubTitle}>{t('Pouch.tax')}</span>
                                                    <div>
                                                        <Trans i18nKey="store-pouch:Pouch.price" values={{
                                        price: `+${formattedPrice(taxPrice, currency)}`,
                                        currency: t(`common:currency.${currency}`)
                                    }} components={[<span className={styles.price}/>,
                                        <span className={classNames(styles.price, styles.won)}/>]}/>
                                                    </div>
                                                </div>}
                                            <div className={classNames(utilStyles.flexRow, utilStyles.justifyContentSpaceBetween, utilStyles.alignItemsCenter, styles.orderRow)}>
                                                <span className={styles.orderSubTitle}>{t('Pouch.shippingFee')}</span>
                                                <div>
                                                    <span className={classNames(styles.price, styles.priceHighlight)}>
                                                        {shippingFeeText}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className={styles.totalPriceContainer}>
                                                <span className={styles.totalPriceTitle}>{t('Pouch.totalPaymentAmount')}</span>
                                                <div>
                                                    <Trans i18nKey="store-pouch:Pouch.price" values={{ price: `${formattedPrice(totalDiscountPrice + shippingFee + taxPrice, currency)}`, currency: t(`common:currency.${currency}`) }} components={[<span className={styles.totalPrice}/>, <span className={classNames(styles.totalPrice, styles.totalWon)}/>]}/>
                                                </div>
                                            </div>
                                            {locale === 'ko' &&
                                <div className={styles.bonusContainer}>
                                                    <span>
                                                        <Trans i18nKey="store-pouch:Pouch.maxBonus" values={{ bonus: `${formattedPrice(Math.round(totalDiscountPrice / 100), currency)}` }} components={[<span className={utilStyles.bold}/>]}/>
                                                    </span>
                                                </div>}
                                        </>}
                            </div>
                        </div>
                        <div className={styles.stickyButtonContainer}>
                            {Boolean(timeString) &&
                    <div className={styles.purchaseInfoContainer}>
                                    <Trans i18nKey="store-pouch:Pouch.timeRemaining" components={[<span className={styles.openTimePrefix}/>]} values={{ timeString }}/>
                                </div>}
                            <div ref={buttonRef} className={classNames(styles.buttonContainer, isMobile && !shouldHideNavBar ? styles.elevated : undefined, styles.shadow)}>
                                {(Boolean(nextAvailableCoupon) || Boolean(bestAvailableCoupon) || user === null) &&
                    <CouponDiscountGaugeBar nextAvailableCoupon={nextAvailableCoupon} bestAvailableCoupon={bestAvailableCoupon} isPriceLoading={isPriceLoading} locale={locale}/>}
                                <div className={styles.buttonWrapper}>
                                    {user === null ?
                    <div className={styles.nonMemberOrderButton}>
                                                <FullButton height={50} onClick={disabled ? handleDisabledButtonClick : () => checkOut(false)} white={!disabled} lightWhite={disabled}>
                                                    <span className={styles.buttonText}>{t('Pouch.nonMemberOrder')}</span>
                                                </FullButton>
                                            </div>
                    :
                        (locale === 'ko' &&
                            <div className={styles.giftOrderButton}>
                                                    <FullButton height={50} onClick={disabled ? handleDisabledGiftButtonClick : () => checkOut(true)} fontSize={16} white={!disabled} lightWhite={disabled}>
                                                        <span>{t('Pouch.gift')}</span>
                                                    </FullButton>
                                                </div>)}
                                    <button onClick={disabled
                    ? handleDisabledButtonClick
                    :
                        (user === null ? handleLoginAndCheckout : () => checkOut(false))} className={classNames(styles.orderButton, totalPrice > 0 && !isPriceLoading && styles.activeOrderButton, styles.longerOrderButton, disabled && styles.disabledOrderButton)}>
                                        {isPriceLoading
                    ? <span className={styles.buttonText}>{t('Pouch.order')}</span>
                    :
                        <>
                                                <span className={styles.buttonText}>
                                                    {purchaseButtonText}
                                                </span>
                                                </>}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </>}
            </div>
        </>);
};
const Pouch = (props) => {
    return (<>
            <_Pouch />
        </>);
};
const WrappedPouch = (props) => {
    return (<Layout isTopBannerHidden>
            <Pouch {...props}/>
        </Layout>);
};
export default WrappedPouch;

    async function __Next_Translate__getStaticProps__1966fcd62ef__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/store/pouch',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1966fcd62ef__ as getStaticProps }
  